import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";

export function Layout() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
    const seg = pathname.split("/").filter(Boolean)[0];
    const label = seg ? seg.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "";
    const priv = /^\/(account|admin|vendor\/(onboarding|dashboard)|profile|addresses|notifications|wallet|orders|checkout|reset-password|verify-email)/.test(pathname);
    let meta = document.querySelector('meta[name="robots"]');
    if (!meta) { meta = document.createElement("meta"); meta.name = "robots"; document.head.appendChild(meta); }
    meta.content = priv ? "noindex, nofollow" : "index, follow";
    document.title = label ? `${label} | Shri Vrindavan Shop` : "Shri Vrindavan Shop — Braj Ki Bhakti, Aapke Ghar Tak";
  }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
